<template>
  <div id="photodoku">
    <div class="innerdoc position-relative shadow-sm" id="coverpage">
      <div class="header col-md-12">
        <div class="row">
          <div class="col-md-6">
            <img :src="logo_one" class="mb-2 img-fluid logo-images-in-docs" alt="img">
          </div>
          <div class="col-md-6 text-right">
            <img :src="logo_two" class="mb-2 img-fluid logo-images-in-docs" alt="img">
          </div>
        </div>
      </div>
      <div class="picdetail">
        <div class="text-center">
          <h2 class="font-weight-bold mb-2">Dokumentation</h2>

          <h3  v-if="selectedDocument.reporttype === '1'" class="text-capitalize  p-1 mb-2" v-html="selectedDocument.reportname"></h3>
          <h3  v-else class="text-capitalize p-1 mb-2"> {{ dateFormat( selectedDocument.reportdate)}} </h3>
          <h3  v-if="selectedDocument.reporttype === '0'" class="text-capitalize p-1 mb-2"> {{ selectedDocument.time }} </h3>

          <h3 class="mb-2 text-capitalize">{{ project.name }}</h3>
          <div class="mb-3 mt-2 cover-image-project">
            <img :src="project_img" class="img-thumbnail" alt="img" style="width: 60%">
          </div>
        </div>

        <div  class="project-info pt-4 pl-2">
          <p>Projekt : {{ project.name }}  </p>
          <p> Projektnummer : {{ project.number }} </p>
          <p> Projektverantwortlicher : {{ project.manager }}<p>
          <p>Projektbeginn : {{ dateFormat(project.startdate) }}</p>
        </div>
      </div>
      <p class="text-center mt-3 position-absolute border-top foot pb-3">
        <span>  Seite 1 von {{ (images.length % 2) === 0 ? parseInt(images.length / 2) + 2 : parseInt(images.length / 2) + 3 }} </span>
        <span class="float-right">projectdocu.com</span>
      </p>
    </div>
  </div>
</template>
<script>
import {formatDate, setAspectRatio} from '../../../common'
export default {
  props: ['theme', 'selectedDocument','logo_one','logo_two','project','project_img'],
  data () {
    return {
      coverImage : '',
    }
  },

  computed: {
    images() {
      return this.$store.state.photoDocumentation.photoContentImages
    }
  },
  methods: {
    dateFormat : (val) => formatDate(val)
  },
  mounted () {
    setAspectRatio()
  }
}
</script>
<style scoped>
.project-info p{
  margin-bottom: 7px;
  font-size: 1rem;
}
.cover-image-project{
  min-height: 17rem;
}
@media (max-width: 1100px) {
  .cover-image-project{
    min-height: auto;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/photoDocumentation/components/Preview/PreviewCoverContent.vue